// removed by extract-text-webpack-plugin
module.exports = {"map-image":"map-modal__map-image__1JllC","button":"map-modal__button__2iGyI","event-venue-container":"map-modal__event-venue-container__2HZcB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/map-modal.scss
// module id = 1347
// module chunks = 1